<button (click)="onClick()" class="sso-button w-100">
  <div class="d-flex flex-row justify-content-center align-items-center w-100 sso-button__container">
    <kh-img [path]="logo" class="sso-button__logo" khA11yHidden></kh-img>
    <div class="sso-button__text">
      {{buttonText}}
    </div>
  </div>
</button>